import { createTheme } from "@mui/material";
import { orange } from "@mui/material/colors";
import { darkMode } from "./constants";

export const theme = createTheme({
  palette: {
    primary: orange,
    mode: darkMode ? "dark" : "light"
  }
});
